import { render, staticRenderFns } from "./EventGeneralInfo.vue?vue&type=template&id=c9644eba&scoped=true"
import script from "./EventGeneralInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventGeneralInfo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventGeneralInfo.vue?vue&type=style&index=0&id=c9644eba&prod&lang=scss&scoped=true"
import style1 from "./EventGeneralInfo.vue?vue&type=style&index=1&id=c9644eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9644eba",
  null
  
)

export default component.exports